import {Avatar} from 'antd'
import {getFullAvatarUrl} from 'apis/model/base'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import React, {useContext} from 'react'
import {IoHome} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {renderIf} from 'views/Shared'
import CourseContext from '../CourseContext'
import Translate from "../../../../modules/local/Translate";
import {FaChalkboardTeacher} from "react-icons/fa";
import {parseDayjs} from "../../../../helpers/datetimeHelpers";

const ActionButtons = ({item}) => {
    const {isLg} = useContext(LayoutContext)
    if (!isLg) return null
    return (
    <div className="flex flex-row space-x-1">
        <Link
            to={getLinkToDetail(item)}
            className="w-10 h-10 rounded-full flex flex-center background-100 hover:bg-primary-100 text-color-500 hover:text-primary">
            <IoHome className="Icon"/>
        </Link>
    </div>
    )
}

const Dates = ({to_date, from_date}) =>
    renderIf(
        from_date || to_date,
        <Translate>
            {(t) => (
                <div className="flex items-center gap-2">
                    <span className="text-xs md:text-sm text-color-500 italic">
                        {`${t('time')} : `}
                    </span>
                    {renderIf(
                        from_date,
                        <span className="font-bold text-xs md:text-sm text-color-200 italic">
                            <span className="font-normal text-color-500 capitalize mr-2">
                                {t('from')}
                            </span>
                            {parseDayjs(from_date).format('DD/MM/YYYY')}
                        </span>
                    )}
                    {renderIf(
                        to_date,
                        <span className="font-bold text-xs md:text-sm text-color-200 italic">
                            <span className="font-normal text-color-500 lowercase mr-2">
                                {t('to')}
                            </span>
                            {parseDayjs(to_date).format('DD/MM/YYYY')}
                        </span>
                    )}
                </div>
            )}
        </Translate>
    )

const CourseSettingHeader = () => {
    const {item} = useContext(CourseContext)
    const {isSm} = useContext(LayoutContext)

    return renderIf(
        item,
        <div className="py-3 w-full container mx-auto">
            <div className="flex items-center gap-3">
                <Avatar
                    size={isSm ? 50 : 80}
                    src={getFullAvatarUrl(item)}
                    icon={<FaChalkboardTeacher size={isSm ? 20 : 40} className="text-color-500"/>}
                    className="flex flex-center border border-color-50 background-200 rounded-lg"
                />
                <div className="flex flex-col flex-1 gap-1">
                    <Link
                        className="font-bold text-sm md:text-xl hover:text-primary no-underline"
                        title={getTitle(item)}
                        to={getLinkToDetail(item)}>
                        {getTitle(item)}
                    </Link>
                    <Dates from_date={item?.start_date} to_date={item?.end_date}/>
                </div>
                <ActionButtons {...{item}} />
            </div>
        </div>
    )
}

export default CourseSettingHeader
